<template>
    <div></div>
</template>


<script>


export default {
    name: "AccountLogout",
    created() {
        this.$store.dispatch('LOGOUT');
        this.$store.dispatch('REMOVE_MENUS');
        this.$store.dispatch('REMOVE_USER_INFORMATION');
        this.$router.push('/account/login');
    }
}
</script>

